import { regionOptions, yearOptions, sortOptions } from '@/mocks/categories';

interface FilterSidebarProps {
  region: string;
  year: string;
  sort: string;
  onRegion: (value: string) => void;
  onYear: (value: string) => void;
  onSort: (value: string) => void;
  onReset: () => void;
}

const groups = [
  { key: 'region' as const, label: '地区', options: regionOptions, icon: 'ri-earth-line' },
  { key: 'year' as const, label: '年份', options: yearOptions, icon: 'ri-calendar-line' },
  { key: 'sort' as const, label: '排序', options: sortOptions, icon: 'ri-arrow-up-down-line' },
];

export default function FilterSidebar({
  region,
  year,
  sort,
  onRegion,
  onYear,
  onSort,
  onReset,
}: FilterSidebarProps) {
  const values: Record<'region' | 'year' | 'sort', string> = { region, year, sort };
  const handlers: Record<'region' | 'year' | 'sort', (value: string) => void> = {
    region: onRegion,
    year: onYear,
    sort: onSort,
  };

  return (
    <div className="flex flex-col gap-6">
      {groups.map((group) => (
        <div key={group.key}>
          <h3 className="flex items-center gap-1.5 text-sm font-semibold text-foreground-900">
            <i className={`${group.icon} text-primary-600`} />
            {group.label}
          </h3>
          <div className="mt-3 flex flex-wrap gap-2">
            {group.options.map((option) => {
              const active = values[group.key] === option;
              return (
                <button
                  key={option}
                  type="button"
                  onClick={() => handlers[group.key](option)}
                  className={`whitespace-nowrap rounded-md px-3 py-1.5 text-sm transition-colors ${
                    active
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-700 hover:bg-primary-100 hover:text-primary-700'
                  }`}
                >
                  {option}
                </button>
              );
            })}
          </div>
        </div>
      ))}
      <button
        type="button"
        onClick={onReset}
        className="flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-700"
      >
        <i className="ri-refresh-line" />
        重置筛选
      </button>
    </div>
  );
}